export const SIMPLE = "simple";
export const MEDIUM = "medium";
export const HARD = "hard";

export default {
  SIMPLE,
  MEDIUM,
  HARD,
};
